<template>
<div class="main my">
  <!-- 课表 -->
  <div class="model-box">

    <!-- 列表 -->
    <div v-for="(item,index) in list" :key="index" class="clear bcw mbm class-card">
      <div class="left class-card__title tac">
          <h2 class="fs3 mbn">第{{index+1}}课</h2>
          <van-tag v-if="classType=='month_card'" type="success" round plain size="mini">月课</van-tag>
          <van-tag v-else type="primary" round plain size="mini">私教</van-tag>
      </div>
      <div class="class-card__info fs2 c6">
        {{item.title}}          
      </div>
      <van-icon class="right c6 fs3 mt15" name="arrow" @click="goTo(item.id)"/>
    </div>

    <div v-if="list.length==0" v-show="none" class="tac c9 fs2 ptm pbm">~ 暂无记录 ~</div>
    <div v-if="list.length!=0 && listTotal>pageSize" class="tac c9 bcw ptm pbw" @click="loadMore()" v-show="loadShow">{{loadTxt}}</div>
  </div>
  <the-tabbar></the-tabbar>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import AvatarBox from '@/components/AvatarBox';
import TheTabbar from '@/components/TheTabbar';
import {Toast} from 'vant';
Vue.use(Toast);
export default {
  components: {
    AvatarBox,TheTabbar
  },
  data() {
    return {
      list:[],
      page: 1,
      pageSize: 15,
      loadShow: true,
      loadTxt: "加载更多",
      listTotal:'', //列表总数
      none:false,
      value:'',
      classType:this.$route.query&&this.$route.query.type //私教or月课
    }
  },
  created(){
    this.fetchData()
  },
  methods: {
    fetchData(more) {
      // 获取课表
      let url = ''
      if(this.classType == 'month_card'){
        // 月课
        url = 'product/getCourseList'
      }else{
        // 私教课
        url = 'club_pt_course/getCourseList'
      }
      this.$http.post(url,{
        id: this.$route.query.id
      }).then(res => {
        // console.log(res)
        if (!res.data.code) {
          let re = res.data.value;
          this.listTotal = re.length
          if(more=='more'){
            //是 加载更多
            this.list = this.list.concat(re);
            this.loadTxt = "加载更多";
            if (re.length < this.pageSize) {
              this.loadShow = false;
            } 
          }else{
            //否 加载更多
            this.list = re
          }                   
        } else {
          Toast.fail(res.data.message);
          this.loadTxt = "加载更多";
        }

        this.none = true //解决“暂无记录”默认显示的问题
      })
    },
    loadMore() {
      //加载更多
      this.loadTxt = "正在加载";
      this.page++;
      this.getList('more');
    },
    goTo(id){
      location.href=`${location.origin}`+'/training/#/courseDetail?id='+id
    },
  }
}
</script>
<style lang="less" scoped>
// 课程信息模块
.mt15{
  margin-top:15px;
}
.class-card {
  padding: .15rem .1rem;
  position: relative;
  display: block;
  &__title {
    width: 0.5rem;
    margin-right: 0.1rem;
  }
  &__info {
    float: left;
    width:calc(100%-0.8rem);
    // display: -webkit-box;
    // -webkit-box-orient: vertical;
    // -webkit-line-clamp: 2;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/manage/ClassDetail.vue